import Ajax from 'global/od/Ajax';

export default (cartEntries = []) => {
	const [gift = {}] = cartEntries;
	const data = { productCode: gift.sku, qty: gift.quantity };

	return Ajax({
		url: '/ajax/premiumshop/gift/add',
		method: 'POST',
		dataType: 'html',
		data,
	});
};
